export const modalConstants = {
  REDIRECT: 'REDIRECT',
  LOGIN: 'LOGIN',
  HIDE: 'MODAL_HIDE',
  USER_PROFILE_ONBOARDING: 'USER_PROFILE_ONBOARDING',
  USER_LOCATION_ONBOARDING: 'USER_LOCATION_ONBOARDING',
  NPS: 'NPS',
  LAST_MINUTE: 'LAST_MINUTE',
};
